// Shared PDF / Excel export helpers for reports.
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

// columns: [{ header, key }], rows: [{ ... }]
export function exportPdf(filename, title, columns, rows, subtitle = "") {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.setTextColor(78, 115, 223);
  doc.text(title, 14, 18);
  if (subtitle) {
    doc.setFontSize(10);
    doc.setTextColor(133, 135, 150);
    doc.text(subtitle, 14, 25);
  }
  autoTable(doc, {
    startY: subtitle ? 30 : 24,
    head: [columns.map((c) => c.header)],
    body: rows.map((r) => columns.map((c) => (r[c.key] ?? "-").toString())),
    headStyles: { fillColor: [78, 115, 223] },
    styles: { fontSize: 9 },
  });
  doc.save(filename.endsWith(".pdf") ? filename : `${filename}.pdf`);
}

export function exportExcel(filename, sheetName, columns, rows) {
  const data = rows.map((r) => {
    const o = {};
    columns.forEach((c) => { o[c.header] = r[c.key] ?? ""; });
    return o;
  });
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  XLSX.writeFile(wb, filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`);
}
